import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '@vds/grids';

import { Body } from '../../common/Typography';
import { VDSTextArea } from '../../common/TextArea';
import { isMobile } from '../../common/Helpers';

import './appointment.css';

const SpecialInstruction = (props) => {
  const { specialInstructionsText, specialInstructionsHeading } = props;

  return (
    <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 9 }}>
      <Row className="noPadding marginTop35">
        <Col className="noPadding">
          <Body primitive="p" size="large">
            {specialInstructionsHeading}
          </Body>
          <Body primitive="span" size="large" color="#6F7171">
            {specialInstructionsText}
          </Body>
        </Col>
        <Col className={`${isMobile() ? 'marginTop24' : 'marginTop16'} noPadding`}>
          <VDSTextArea
            readOnly={false}
            disabled={false}
            required={false}
            id="specInst"
            name="specInst"
            label="Special Instructions"
            onChange={(e) => {
              props.onSpecialInstructionChange(e);
            }}
            width={isMobile() && '100%'}
            maxLength={256}
          />
        </Col>
      </Row>
    </Grid>
  );
};

SpecialInstruction.propTypes = {
  onSpecialInstructionChange: PropTypes.func,
  specialInstructionsHeading: PropTypes.string,
  specialInstructionsText: PropTypes.string,
};

export default SpecialInstruction;
